import { render, staticRenderFns } from "./VDataTableCustomHeaderFiltersAutocomplete.vue?vue&type=template&id=ef5f6ecc&scoped=true"
import script from "./VDataTableCustomHeaderFiltersAutocomplete.vue?vue&type=script&lang=js"
export * from "./VDataTableCustomHeaderFiltersAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./VDataTableCustomHeaderFiltersAutocomplete.vue?vue&type=style&index=0&id=ef5f6ecc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5f6ecc",
  null
  
)

export default component.exports